module.exports = __webpack_public_path__ + "img/home-results.6f557c26.svg";